// extracted by mini-css-extract-plugin
module.exports = {"ibc":"Denom_ibc__3WALN"};